// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"861":"css/app.6724","7234":"css/admin-app.6724"}[chunkId] + ".css";
};